import _ from 'lodash';
import { ThrowErrorMsg } from '../util';

import {
  ADD_AREA,
  DELETE_AREA,
} from '../types';
import apiService, { deleteRequest } from '../../services.js/apiService';

const basePath = `${process.env.REACT_APP_API_URL}/staff`;

// TODO: need to fix issue in the area UI, where it is throwing error
// when we call addArea even though the api call was successful.
export const addArea = (data) => async (dispatch) => {
  try {
    const area = await apiService.addArea(data); //
    dispatch({
      type:    ADD_AREA,
      payload: area,
    });

    return area;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};

export const deleteArea = (id) => async (dispatch) => {
  try {
    console.log(id);
    const res = await deleteRequest(`${basePath}/area/${id}`);

    dispatch({
      type:    DELETE_AREA,
      payload: id,
    });

    return res;
  } catch (err) {
    ThrowErrorMsg(err, dispatch);
  }
};
